import type { VariableBank } from '../../../app/utils/VariableBank';
import type { LayoutTextProcessor } from '../populateLayouts/LayoutText';
import { VariableBankUtils } from '../../../app/utils/VariableBankUtils';

export function createVariableTextProcessor(bank: VariableBank): LayoutTextProcessor {
  return (textObject): void => {
    VariableBankUtils.applyVariablesToText(bank, textObject);
  };
}
